<template>
    <div class="w-4/5 mt-4 px-6 py-4 mx-auto flex flex-col">
        <accordion-list v-cloak>
            <accordion-item :item-id="1">
                <template slot="header">
                    {{ trans.get('anomaly.testata') }}
                </template>
                <template slot="content">
                    <div class="flex justify-between">
                        <div class="flex flex-col w-1/3 bg-blue-100 p-2 mb-2 border rounded">
                            <section class="flex justify-between items-center">
                                <h2 class="font-extrabold text-2xl py-2 px-2 text-blue-700 tracking-wide">
                                    {{ anomaly.codice }}</h2>
                                <span class="px-4 py-2 rounded-l-full rounded-r-full font-bold"
                                      :class="`level-badge-${anomaly.livello}`">
                                        {{ trans.get(`anomaly.${anomaly.livello}`) }}
                                    </span>
                            </section>
                            <section class="flex justify-end px-2 w-1/3 font-bold">
                                <editable-cell-data-picker
                                        :id="anomaly.id"
                                        :data="anomaly.data_creazione | reversed"
                                        field="data_creazione"
                                        :url="url"
                                        class="text-blue-600 text-md mr-1"
                                >
                                </editable-cell-data-picker>
                                <span class="text-blue-400 font-bold">
                                        <i class="fas fa-pencil-alt fa-xs"></i>
                                    </span>
                            </section>
                        </div>

                        <div class="flex flex-col w-2/3 bg-blue-200 p-2 mb-2 border rounded ml-2">
                            <section class="flex items-center py-2 px-2 text-2xl font-extrabold text-blue-700 tracking-widest">
                                <span class="mr-2">{{ anomaly.quantita }} x</span>
                                <span class="mr-2"
                                      v-text="anomaly.cod_articolo_parte_1 ? anomaly.cod_articolo_parte_1 : anomaly.parte_1"></span>
                                <span class="tracking-normal font-bold">( {{ formatter.format(anomaly.costo_totale) }})</span>
                                <div class="ml-5 py-1 px-2 bg-red-700 text-xs font-bold text-white tracking-tighter uppercase rounded"
                                     v-text="anomaly.scarto_parte_1 ? trans.get('anomaly.rilavorazione_scarto') : trans.get('anomaly.solo_rilavorazione')"
                                     v-show="anomaly.livello === 'medio'"
                                >
                                </div>
                            </section>
                            <h2 class="text-blue-600 font-bold text-md px-2">{{ anomaly.modello }}
                                <span
                                    class="font-normal">({{ trans.get(`anomaly.${anomaly.stadio}`)}})
                                </span>
                            </h2>
                        </div>
                    </div>

                    <div class="anomaly-block flex-col mt-10">
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">{{ trans.get('anomaly.dettaglio') }} <span><i
                                    class="fas fa-pencil-alt fa-xs"></i></span></div>
                            <div class="anomaly-edit-block-html bg-white py-2">
                                <editable-with-editor
                                        :id="anomaly.id"
                                        :data="anomaly.dettaglio"
                                        :field="'dettaglio'"
                                        :url="url"
                                        class="anomaly-block-data"
                                >

                                </editable-with-editor>
                            </div>
                        </div>

                    </div>

                    <div class="anomaly-block flex-col">

                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">{{ trans.get('anomaly.argomento') }} <span><i
                                    class="fas fa-pencil-alt fa-xs"></i></span></div>
                            <div class="anomaly-edit-block-html bg-white py-2">
                                <editable-with-editor
                                        :id="anomaly.id"
                                        :data="anomaly.argomento"
                                        :field="'argomento'"
                                        :url="url"
                                        class="anomaly-block-data"
                                >

                                </editable-with-editor>
                            </div>
                        </div>
                    </div>
                </template>
            </accordion-item>
            <accordion-item :item-id="2">
                <template slot="header">
                    {{ trans.get('anomaly.immagini') }}
                </template>
                <template slot="content">
                    <div class="flex flex-col">
                        <images-manager model="anomalies" :id="anomaly.id"></images-manager>
                    </div>
                </template>
            </accordion-item>
            <accordion-item :item-id="3">
                <template slot="header">
                    {{ trans.get('anomaly.rilavorazione') }}
                </template>
                <template slot="content">

                    <div class="anomaly-edit-block">
                        <div class="anomaly-edit-block-header">{{ trans.get('anomaly.rilavorazione') }}</div>
                        <div class="anomaly-edit-block-data">
                            <input type="radio" name="rilavorazione" :value="false"
                                   v-model="anomaly.rilavorazione"><span
                                class="mx-3">
                                    {{ trans.get('general.false') }}
                                </span>
                            <input type="radio" name="rilavorazione" :value="true"
                                   v-model="anomaly.rilavorazione"><span class="mx-3">
                                    {{ trans.get('general.true') }}
                                </span>
                        </div>
                    </div>
                    <div class="anomaly-edit-block flex-col" v-if="anomaly.rilavorazione">
                        <div class="anomaly-edit-block-header w-full">{{ trans.get('anomaly.attivita_rilavorazione') }}</div>
                        <div class="anomaly-edit-block-html w-full">
                            <editable-with-editor
                                    :id="anomaly.id"
                                    :data="!anomaly.attivita_rilavorazione ? 'Inserisci attività ...' : anomaly.attivita_rilavorazione"
                                    :field="'attivita_rilavorazione'"
                                    :url="url"
                                    class="anomaly-block-data"
                            >

                            </editable-with-editor>
                        </div>

                        <div class="flex justify-between mt-2">
                            <div class="anomaly-edit-block">
                                <div class="anomaly-edit-block-header">{{ trans.get('anomaly.tempo_rilavorazione') }}</div>
                                <div class="anomaly-edit-block-data uneditable">
                                  {{ anomaly.tempo_rilavorazione }}
                                </div>
                            </div>
                            <div class="anomaly-edit-block">
                                <div class="anomaly-edit-block-header">{{ trans.get('anomaly.tempo_rilavorazione_reale') }}
                                    <span><i
                                            class="fas fa-pencil-alt fa-xs"></i></span></div>
                                <editable-cell-input
                                        :id="anomaly.id"
                                        :data="!anomaly.tempo_rilavorazione_reale ? 'n.d.' : anomaly.tempo_rilavorazione_reale"
                                        :field="'tempo_rilavorazione_reale'"
                                        :url="url"
                                        class="anomaly-edit-block-data"
                                        @data-has-changed="updateRilavorazioneCost"
                                >
                                </editable-cell-input>
                            </div>
                            <div class="anomaly-edit-block">
                                <div class="anomaly-edit-block-header">{{ trans.get('anomaly.costo_rilavorazione') }}</div>
                                <div class="anomaly-edit-block-data uneditable">
                                    {{ !anomaly.costo_rilavorazione ? 'n.d.' : formatter.format(anomaly.costo_rilavorazione) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </accordion-item>
            <accordion-item :item-id="4">
                <template slot="header">
                    {{ trans.get('anomaly.cause') }}
                </template>
                <template slot="content">
                    <div class="anomaly-block">
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">
                                {{ trans.get('anomaly.causa_radice_1') }}
                            </div>
                            <div class="anomaly-edit-block-data">
                                <editable-cell-input
                                        :id="anomaly.id"
                                        :data="!anomaly.causa_radice_1 ? 'n.d.' : anomaly.causa_radice_1"
                                        :field="'causa_radice_1'"
                                        :url="url"
                                        class="anomaly-edit-block-data"
                                >

                                </editable-cell-input>
                            </div>
                        </div>
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">
                                {{ trans.get('anomaly.causa_radice_2') }}
                            </div>
                            <div class="anomaly-edit-block-data">
                                <editable-cell-input
                                        :id="anomaly.id"
                                        :data="!anomaly.causa_radice_2 ? 'n.d.' : anomaly.causa_radice_2"
                                        :field="'causa_radice_2'"
                                        :url="url"
                                        class="anomaly-edit-block-data"
                                >

                                </editable-cell-input>
                            </div>
                        </div>
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">
                                {{ trans.get('anomaly.reparto_rilevazione') }}
                            </div>
                            <div class="anomaly-edit-block-data">
                                <editable-cell-selector-v2
                                        :id="anomaly.id"
                                        :data="!anomaly.reparto_rilevazione ? 'n.d.' : anomaly.reparto_rilevazione"
                                        :field="'reparto_rilevazione'"
                                        :dataset="departments"
                                        :url="url"
                                        class="anomaly-edit-block-data"
                                >

                                </editable-cell-selector-v2>
                            </div>
                        </div>
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">
                                {{ trans.get('anomaly.reparto_nascita') }}
                            </div>
                            <div class="anomaly-edit-block-data">
                                <editable-cell-selector-v2
                                        :id="anomaly.id"
                                        :data="!anomaly.reparto_nascita ? 'n.d.' : anomaly.reparto_nascita"
                                        :field="'reparto_nascita'"
                                        :dataset="departments"
                                        :url="url"
                                        class="anomaly-edit-block-data"
                                >

                                </editable-cell-selector-v2>
                            </div>
                        </div>
                    </div>
                    <div class="anomaly-block">
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">
                                {{ trans.get('anomaly.costo_nascita') }}
                            </div>
                            <div class="anomaly-edit-block-data">
                                <editable-cell-input
                                        :id="anomaly.id"
                                        :data="!anomaly.costo_nascita ? 'n.d.' : anomaly.costo_nascita"
                                        :field="'costo_nascita'"
                                        :url="url"
                                        class="anomaly-edit-block-data"
                                >

                                </editable-cell-input>
                            </div>

                        </div>
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">
                                {{ trans.get('anomaly.tempo_nascita') }}
                            </div>
                            <div class="anomaly-edit-block-data">
                                <editable-cell-input
                                        :id="anomaly.id"
                                        :data="!anomaly.tempo_nascita ? 'n.d.' : anomaly.tempo_nascita"
                                        :field="'tempo_nascita'"
                                        :url="url"
                                        class="anomaly-edit-block-data"
                                >

                                </editable-cell-input>
                            </div>
                        </div>
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">
                                {{ trans.get('anomaly.costo_rilevazione') }}
                            </div>
                            <div class="anomaly-edit-block-data">
                                <editable-cell-input
                                        :id="anomaly.id"
                                        :data="!anomaly.costo_rilevazione ? 'n.d.' : anomaly.costo_rilevazione"
                                        :field="'costo_rilevazione'"
                                        :url="url"
                                        class="anomaly-edit-block-data"
                                >

                                </editable-cell-input>
                            </div>
                        </div>
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">
                                {{ trans.get('anomaly.tempo_lavorazione') }}
                            </div>
                            <div class="anomaly-edit-block-data">
                                <editable-cell-input
                                        :id="anomaly.id"
                                        :data="!anomaly.tempo_lavorazione ? 'n.d.' : anomaly.tempo_lavorazione"
                                        :field="'tempo_lavorazione'"
                                        :url="url"
                                        class="anomaly-edit-block-data"
                                >

                                </editable-cell-input>
                            </div>
                        </div>
                    </div>
                </template>
            </accordion-item>
            <accordion-item :item-id="5">
                <template slot="header">
                    {{ trans.get('anomaly.matricole') }}
                </template>
                <template slot="content">
                    <div class="anomaly-block">
                        <div class="anomaly-edit-block">
                            <div class="anomaly-edit-block-header">
                                {{ trans.get('anomaly.matricole') }}
                            </div>
                            <div class="anomaly-edit-block-data">
                                <input-tag
                                        v-model="tags"
                                        @update:tags="updateTags"
                                >

                                </input-tag>
                            </div>
                        </div>
                    </div>
                </template>
            </accordion-item>
        </accordion-list>
    </div>
</template>

<script>
    import AccordionList from "../utilities/AccordionList";
    import AccordionItem from "../utilities/AccordionItem";
    import EditableCellDataPicker from "../EditableCellDataPicker";
    import EditableCellSelectorV2 from "../utilities/EditableCellSelectorV2";
    import EditableCellInput from "../EditableCellInput";
    import EditableWithEditor from "../utilities/EditableWithEditor";
    import EditableSearchableInput from "../searchable/EditableSearchableInput";
    import ImagesManager from "../utilities/ImagesManager";

    import InputTag from 'vue-input-tag'

    import Utilities from "../../mixins/Utilities";
    import Searchable from "../../mixins/Searchable";

    export default {
        mixins: [Utilities, Searchable],

        props: ['dataset'],

        components: {
            AccordionList,
            AccordionItem,
            EditableCellDataPicker,
            EditableCellSelectorV2,
            EditableCellInput,
            EditableWithEditor,
            EditableSearchableInput,
            ImagesManager,
            InputTag
        },

        data() {
            return {
                domain: process.env.MIX_API_DOMAIN,
                url: '/qms/anomalies/',
                anomaly: this.dataset,
                livelli: [
                    'Basso',
                    'Medio',
                    'Critico'
                ],
                stadi: [
                    'Semilavorato',
                    'Arpa Lamata',
                    'Arpa Verniciata',
                    'Arpa Verniciata e Controllata',
                    'Arpa Montata a Legno',
                    'Arpa Finita'
                ],
                reasons: [],
                departments: [],
                domain: process.env.MIX_API_DOMAIN,
                tag: '',
                tags: [],
            }
        },

        created() {
            // Get Reasons
            axios.get('/qms/reason')
                .then(({data}) => {
                    data.forEach((reason) => {
                        this.reasons.push(reason.causale);
                    })
                });

            //Get Departments
            axios.get('/departments')
                .then(({data}) => {
                    data.forEach((department) => {
                        this.departments.push(department.cod_reparto)
                    })

                });

            this.tags = this.dataset.matricole === null ? this.tags = [] : JSON.parse(this.dataset.matricole);
        },

        computed: {
            rilavorazione() {
                return this.anomaly.rilavorazione;
            },

            levelBadgeClass() {
                return 'bg-red-300 text-red-700';
            }
        },

        watch: {
            rilavorazione() {
                axios.patch(`/qms/anomalies/${this.anomaly.id}`, {rilavorazione: this.anomaly.rilavorazione})
                    .then(() => console.log('Updated Rilavorazione!'))
            }
        },

        filters: {
            round(value) {
                return parseFloat(value).toFixed(2);
            }
        },

        methods: {
            onPart2Selected(item) {
                this.anomaly.cod_articolo_parte_2 = item.cod_articolo_parte_2;

                let payload = {};

                //Get the Part Number
                axios.get(`/items/${item.cod_articolo_parte_2}`)
                    .then(({data}) => {
                        this.anomaly.parte_2 = data.part_number;
                        this.anomaly.des_articolo_parte_2 = data.descrizione;

                        payload.parte_2 = data.part_number;
                        payload.des_articolo_parte_2 = data.descrizione;

                        //Get the Part Number Description
                        axios.get(`/part-numbers/${data.part_number}`)
                            .then(({data}) => {
                                this.anomaly.des_parte_2 = data.descrizione;
                                payload.des_parte_2 = data.descrizione;

                                axios.patch(`/qms/anomalies/${this.anomaly.id}`, payload)
                                    .then(() => {
                                        console.log('Aggiornato Dati Parte 2');
                                    })
                            })
                    });

                //Get Part 2 Cost
                axios.get(`${this.domain}/articoli/${item.cod_articolo_parte_2}`)
                    .then(({data}) => {
                        this.anomaly.costo_parte_2 = data.data[0].costo;

                        axios.patch(`/qms/anomalies/${this.anomaly.id}`, {costo_parte_2: data.data[0].costo})
                            .then(() => {
                                console.log('Aggiornato Costo Parte 2');
                            });
                    });
            },

            updateCostoTotale() {

                if (this.anomaly.scarto_parte_1) {
                    return this.anomaly.costo_rilavorazione + (parseFloat(this.anomaly.costo_parte_1) * this.anomaly.quantita);
                }

                return this.anomaly.costo_rilavorazione;
            },

            updateRilavorazioneCost(time) {

                this.anomaly.costo_rilavorazione = parseFloat(time.tempo_rilavorazione_reale) * window.rework_cost * this.anomaly.quantita;

                this.anomaly.costo_totale = this.updateCostoTotale();

                let payload = {costo_rilavorazione: this.anomaly.costo_rilavorazione, costo_totale: this.anomaly.costo_totale};

                axios.patch(`/qms/anomalies/${this.anomaly.id}`, payload)
                    .then(() => {
                        this.$toastr.s('Rework Cost Updated');
                    })
            },

            updateTags(tags) {
                axios.patch(`/qms/anomalies/${this.anomaly.id}`, {matricole: JSON.stringify(tags)})
            }
        }

    }
</script>

<style lang="scss" scoped>
    .anomaly-block {
        @apply w-full flex justify-between mb-4;
    }

    .anomaly-edit-block {
        @apply flex flex-col text-base;

        &-header {
            @apply flex justify-between items-center px-4 py-2 bg-blue-100 text-blue-700 font-bold uppercase rounded-t-lg;

            span {
                @apply .ml-6;
            }
        }

        &-data {
            @apply .font-bold .text-right .px-4 .py-2 bg-white rounded-b-lg;
        }

        &-html {
            @apply text-left p-2 rounded-b-lg;
        }
    }

    .uneditable {
        @apply .bg-gray-200;
    }

    .level-badge-basso {
        @apply bg-green-300 text-green-700;
    }

    .level-badge-medio {
        @apply bg-yellow-300 text-yellow-700;
    }

    .level-badge-critico {
        @apply bg-red-300 text-red-700;
    }
</style>